/**
 * An array of numbers representing an `xy`, `xyz` or `xyzm` coordinate.
 * Example: `[16, 48]`.
 * @typedef {Array<number>} Coordinate
 * @api
 */

export function createStringYX(fractionDigits) {
  return (
    /**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */
    function (coordinate) {
      return toStringYX(coordinate, fractionDigits);
    }
  );
}

export function toStringYX(coordinate, fractionDigits) {
  return format(coordinate, "{y}, {x}", fractionDigits);
}

export function format(coordinate, template, fractionDigits) {
  if (coordinate) {
    return template
      .replace("{x}", coordinate[0].toFixed(fractionDigits))
      .replace("{y}", coordinate[1].toFixed(fractionDigits));
  }
  return "";
}
